import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import React, { CSSProperties } from 'react'
import { CustomArrowProps } from 'react-slick'

const mergeSlickArrowButtonStyle = (style?: CSSProperties): CSSProperties => ({
  ...style,
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const useStyles = makeStyles(() => ({
  arrow: {
    overflow: 'visible',
    '&:focus-visible img': {
      outline: '3px solid #005fcc',
      outlineOffset: 4,
      borderRadius: 8,
    },
  },
}))

interface SlickArrowProps {
  nextLabel: string
  prevLabel: string
}

export function createSlickArrows({ nextLabel, prevLabel }: SlickArrowProps) {
  const NextArrow = ({
    onClick,
    style,
    className,
  }: CustomArrowProps): JSX.Element => {
    const classes = useStyles()
    return (
      <IconButton
        type="button"
        onClick={onClick}
        aria-label={nextLabel}
        className={`${className} ${classes.arrow}`}
        style={mergeSlickArrowButtonStyle(style)}
      >
        <img
          style={{
            width: 42,
            height: 75,
            marginRight: 20,
          }}
          src={`${process.env.PUBLIC_URL}/assets/icons/arrow_right.svg`}
          alt=""
          aria-hidden="true"
          width="42px"
          height="75px"
          loading="lazy"
        />
      </IconButton>
    )
  }

  const PrevArrow = ({
    onClick,
    style,
    className,
  }: CustomArrowProps): JSX.Element => {
    const classes = useStyles()
    return (
      <IconButton
        type="button"
        onClick={onClick}
        aria-label={prevLabel}
        className={`${className} ${classes.arrow}`}
        style={mergeSlickArrowButtonStyle(style)}
      >
        <img
          style={{
            width: 42,
            height: 75,
            marginLeft: 20,
          }}
          src={`${process.env.PUBLIC_URL}/assets/icons/arrow_left.svg`}
          alt=""
          aria-hidden="true"
          width="42px"
          height="75px"
          loading="lazy"
        />
      </IconButton>
    )
  }

  return { NextArrow, PrevArrow }
}
